import React, { useState } from "react";
import { MDBDataTable } from "mdbreact";
import classes from "./Table.module.css";
import { Link } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  Typography,
  DialogContentText,
} from "@mui/material";
import { get_event_attributes } from "../Search/Network_Calls";

const Table = (props) => {
  console.log("sgsgsggggggggggggggggg", props);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedAttributes, setSelectedAttributes] = useState(null);
  const [attributeDesc, setattributeDesc] = useState(null);

  const eventAttributes = async (dataItem) => {
    setLoading(true);
    console.log("data item", dataItem);
    const result = await get_event_attributes(
      dataItem.source_journey_id,
      props.implId
    );
    console.log("result from infooooooo", result);

    if (result.status === 200) {
      const res = result.data.details;
      setattributeDesc(res);
      setLoading(false);
    } else {
      console.log("Error in fetching this event attribute");
    }
  };

  const handleViewAttributes = async (dataItem) => {
    eventAttributes(dataItem);
    const attributes = mapAttributes(dataItem);
    setSelectedAttributes(attributes);
    setOpen(true);
  };

  const mapAttributes = (dataItem) => {
    const mappedAttributes = {};

    console.log("strrtriii", attributeDesc);
    if (attributeDesc) {
      attributeDesc.forEach((desc) => {
        const attributeKey = `attribute_${desc.rawsoattributemappedto
          .split(" ")
          .pop()}`;
        if (dataItem[attributeKey]) {
          mappedAttributes[desc.attributename] = dataItem[attributeKey];
        }
      });
    }

    return {
      ...dataItem,
      ...mappedAttributes,
    };
  };

  const handleClose = () => {
    setOpen(false);
  };

  const transformAttributes = (attributes) => {
    const transformedAttributes = {};

    const attributeMap = {};
    attributeDesc.forEach((desc) => {
      attributeMap[
        `attribute_${desc.rawsoattributemappedto.split(" ").pop()}`
      ] = desc.attributename;
    });

    for (const key in attributes) {
      if (key.startsWith("attribute_")) {
        const newKey = attributeMap[key];
        if (newKey) {
          transformedAttributes[newKey] = attributes[key];
        }
      } else {
        transformedAttributes[key] = attributes[key];
      }
    }

    return transformedAttributes;
  };

  const data = {
    columns: [
      { label: "External Id", field: "external_id", sort: "asc" },
      { label: "Source", field: "sources", sort: "asc", width: 150 },
      { label: "Journey Stage", field: "stage", sort: "asc", width: 200 },
      { label: "Status", field: "status", sort: "asc", width: 250 },
      { label: "Journey Date", field: "date", sort: "asc", width: 250 },
      {
        label: "Start Date",
        field: "days_journey_started",
        sort: "asc",
        width: 100,
      },
      {
        label: "Days in Stage",
        field: "days_in_stage",
        sort: "asc",
        width: 250,
      },
      { label: "Engagement Score", field: "engagement_score", sort: "asc", width: 250 },
      { label: "View Interaction Details", field: "attributesButton", width: 250 },
    ],
    rows: props.data.map((el) => ({
      ...el,
      date: new Date(el.date).toLocaleDateString(),
      attributesButton: (
        <Link
          style={{
            color: "#FF762B",
            fontSize: "16px",
            fontWeight: "normal",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={() => handleViewAttributes(el)}
        >
          View Interaction Details
        </Link>
      ),
    })),
  };

  //console.log("Transformed Attributes: ", transformAttributes(selectedAttributes));

  return (
    <div className={classes.mainTable}>
      <MDBDataTable
        striped
        bordered
        small
        data={data}
        entriesOptions={[20, 40, 60, 100]}
        entries={20}
      />

      {loading != true ? (
        <Dialog open={open} onClose={handleClose}>
          <DialogTitle>
            <strong>Attributes</strong>
          </DialogTitle>
          <DialogContent>
            <DialogContentText sx={{ color: "black" }}>
              {selectedAttributes ? (
                <Grid container spacing={2}>
                  {Object.keys(transformAttributes(selectedAttributes)).map(
                    (key) => (
                      <Grid item xs={12} key={key}>
                        <Typography variant="body1">
                          <strong>
                            {key.charAt(0).toUpperCase() +
                              key.slice(1).toLowerCase()}
                            :
                          </strong>{" "}
                          {transformAttributes(selectedAttributes)[key] ||
                            "N/A"}
                        </Typography>
                      </Grid>
                    )
                  )}
                </Grid>
              ) : (
                <Typography>No attributes available.</Typography>
              )}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="error" variant="contained">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Table;
